module.exports = __webpack_public_path__ + "static/media/taiwushan_web.d833aa1a.webp";